import barba from '@barba/core';
import collapse from "../components/collapse/collapse";
import scrollTo, {scrollStart, scrollStop} from "../modules/lenis";
import BurgerMenu from "../components/btn/burgerMenu";
import ServicesScrollTo from "../modules/servicesScrollTo";

function delay(n) {
    n = n || 500;
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n);
    });
}

if ($('.logged-in.admin-bar').length < 1) {

    barba.hooks.beforeLeave(() => {
        scrollDestroy();
    });

    barba.hooks.beforeEnter(() => {
    });

    barba.hooks.afterEnter(() => {
        //Mettre à jour les items etc
        $('.menu li').each(function () {
            $(this).removeClass(['current-menu-item', 'current_page_item']);

            if ($(this).find('a')[0].pathname == data.next.url.path) {
                $(this).addClass(['current-menu-item', 'current_page_item']);
            }
        });
    });

    /**
     * RESET LE SCROLL
     */
    barba.hooks.before(() => {

    });
    barba.hooks.afterEnter(() => {

    })
    /**
     * LOAD LES SCRIPTS
     */
    barba.hooks.after(() => {

        collapse();
        BurgerMenu();
        ServicesScrollTo();

        ga('set', 'page', window.location.pathname);
        ga('send', 'pageview');
    })

    /**
     * CHANGE HEAD
     */
    barba.hooks.afterLeave((data) => {
        /**
         * Change body Class
         */
        var nextHtml = data.next.html;
        var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml)
        var bodyClasses = $(response).filter('notbody').attr('class')

        $("body").attr("class", bodyClasses);

        var $newPageHead = $('<head />').html(
            $.parseHTML(
                data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0],
                document,
                true
            )
        );

        /**
         * Update meta Head
         */
        var headTags = [
            "script[src*='uutils.fcg']",
            "meta[name='keywords']",
            "meta[name='description']",
            "meta[property^='og']",
            "meta[name^='twitter']",
            'meta[itemprop]',
            'link[itemprop]',
            "link[rel='prev']",
            "link[rel='next']",
            "link[rel='canonical']",
        ].join(',');
        $('head').find(headTags).remove();
        $newPageHead.find(headTags).appendTo('head');
    });


    barba.init({
        transitions: [{
            sync: false,

            async leave(data) {

                const done = this.async();

                $('.menu li').each(function () {
                    $(this).removeClass('current-menu-item');

                    if ($(this).find('a')[0].pathname == data.next.url.path) {
                        $(this).addClass('current-menu-item');
                    }
                });

                TweenMax.fromTo($('main'), .5, {
                    opacity: 1,
                    ease: Power3.easeInOut
                }, {
                    opacity: 0,
                    ease: Power3.easeInOut
                })

                TweenMax.fromTo($('.c-animation__general'), .6, {
                    scaleX: 0,
                }, {
                    scaleX: 1,
                    transformOrigin: 'left',
                    ease: Power3.easeInOut
                });

                setTimeout(function () {
                    TweenMax.fromTo($('.c-animation__general'), .6, {
                        scaleX: 1,
                    }, {
                        scaleX: 0,
                        transformOrigin: 'right',
                        ease: Power3.easeInOut
                    });

                    TweenMax.fromTo($('main'), .5, {
                        opacity: 0,
                        ease: Power3.easeInOut
                    }, {
                        opacity: 1,
                        ease: Power3.easeInOut,
                        delay: .6
                    })
                }, 600)

                await delay(600);
                done();
            },
        }]
    });
}

$('.noBarba').click(function () {
    barba.destroy();
})
